import { getRouteLocale, isOpenedInIframe } from "./index.js";

/**
 * Routes under the locale root use an optional prefix (e.g. `/fr/...`) when the active
 * language is non-default. Strip it so allowlist checks match Router’s logical paths.
 */
export const stripRouteLocaleFromPathname = (pathname = "", language = "") => {
	const prefix = getRouteLocale(language);
	if (!prefix) return pathname || "/";
	if (pathname === prefix) return "/";
	if (pathname.startsWith(`${prefix}/`)) {
		const rest = pathname.slice(prefix.length);
		return rest || "/";
	}
	return pathname || "/";
};

// Logical paths allowed inside an iframe (public intake, staff intake config, pharmacy notes, error redirects).
const ALLOWED_IFRAME_PREFIXES = ["/patient-intake", "/user/patient-intake", "/notes", "/error"];

const withLeadingSlash = (path) => (path.startsWith("/") ? path : `/${path}`);

const matchesAllowedPrefix = (path, prefix) => path === prefix || path.startsWith(`${prefix}/`);

/**
 * Whether the current URL may render normal app UI when `window` is embedded in an iframe.
 */
export const isIframeAllowedPathname = (pathname = "", language = "") => {
	const path = withLeadingSlash(stripRouteLocaleFromPathname(pathname, language));
	return ALLOWED_IFRAME_PREFIXES.some((prefix) => matchesAllowedPrefix(path, prefix));
};

/**
 * When true, Router should render the fullscreen “access denied” screen instead of routes.
 * Keeps iframe detection and pathname rules in one module.
 */
export const shouldShowIframeAccessDenied = (pathname, language) =>
	isOpenedInIframe() && !isIframeAllowedPathname(pathname, language);
